import { map, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SettingsService } from '../services/settings.service';
import { ServerResponse } from '../response';
import { CloudFile } from '../models/cloudFile';
import { GalleryType } from '../models/gallery-type';

@Injectable({
  providedIn: 'root',
})
export class AttachmentDomainService {
  constructor(
    private settingService: SettingsService,
    private http: HttpClient
  ) {}

  // Удаляет приложение из базы
  deleteAttachment(galleryType: GalleryType, galleryUid: string, attType: 'Images' | 'Files' | 'Links', file: CloudFile): Observable<any> {
    return this.http
      .delete<ServerResponse<any>>(
        `${this.settingService.settings.urlGTM}/api/attachment?objType=${galleryType}&objUid=${galleryUid}&attType=${attType}&url=${file.uid}`
      )
      .pipe(
        map((res: any) => res.data)
      );
  }

  // Добавляет приложение в базу
  addAttachment(objType: GalleryType, objUid: string, attType: 'Images' | 'Files' | 'Links', file: CloudFile): Observable<any> {
    return this.http
      .post<ServerResponse<any>>(
        `${this.settingService.settings.urlGTM}/api/attachment`,
        {
          objType,
          objUid,
          attType,
          url: file.uid,
          description: file.description,
          private: file.isPrivate ? 1 : 0,
          docType: file.docType,
          validUntil: file.validUntil,
        }
      )
      .pipe(
        map((res: any) => res.data)
      );
  }

  // Получает список приложений (картинок/файлов/ссылок)
  getAttachmentList(objType: string, objUid: string, attType: string): Observable<any> {
    return this.http
      .get(`${this.settingService.settings.urlGTM}/api/attachment/list`, {
        params: {
          objType,
          objUid,
          attType,
        },
      })
      .pipe(
        map((res: any) => res.data)
      );
  }

  // Получает список типов документов для приложений
  getDocTypeList(): Observable<any[]> {
    return this.http
      .get(`${this.settingService.settings.urlGTM}/api/attachment/doc_type/list?lang=${this.settingService.selectedLang}`)
      .pipe(
        map((res: any) => res.data)
      );
  }
}
